/**
 * Service for handling shift display logic based on manager preferences
 */
import { ShiftDisplayType } from '../Enums';
import timeService from './TimeService';

/**
 * Get the display name for a shift based on the shift display preference
 * @param {Object} shiftTemplate - The shift template object
 * @param {string} shiftTemplate.label - The shift label
 * @param {string} shiftTemplate.name - The shift name
 * @param {number} shiftTemplate.startTime - The shift start time (epoch)
 * @param {number} shiftTemplate.endTime - The shift end time (epoch)
 * @param {string} shiftDisplayType - The display preference: ShiftDisplayType.ShiftLabel or ShiftDisplayType.ShiftTime
 * @returns {string} The display name for the shift
 */
export const getShiftDisplayName = (shiftTemplate, shiftDisplayType) => {
    const { label, name, startTime, endTime } = shiftTemplate;

    // If preference is "ShiftTime", always show times
    if (shiftDisplayType === ShiftDisplayType.ShiftTime) {
        return timeService.calculateShiftTimes(startTime, endTime);
    }

    // If preference is "ShiftLabel" (or default), show label with fallback to times
    // Priority: label > name > times
    if (label) {
        return label;
    }

    if (name) {
        return name;
    }

    // Fallback to times if no label or name
    return timeService.calculateShiftTimes(startTime, endTime);
};

export default {
    getShiftDisplayName,
};

